<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">{{ comment ? 'Изменить' : 'Добавить' }} комментарий</div>
				<div class="popup__close" @click="$emit('close')"></div> 
			</div>
			<div class="popup__content">
				<div class="popup__form">
					<InputTextarea v-model="formData.comment" :errors="v$.formData.comment.$errors"/>
				</div>
				<div class="popup__btns">
					<button class="btn btn--color" @click="handleSubmit">{{ comment ? 'Изменить' : 'Добавить' }}</button>
					<button class="btn btn--border" @click="$emit('close')">Отменить</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

import useVuelidate from "@vuelidate/core";
import {required, helpers, minLength} from '@vuelidate/validators'
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";

const {withMessage} = helpers

export default {
	name: 'AddEditTenderCommentPopup',
	emits: ['close', 'addComment'],
	components: { InputTextarea },
	props: {
		comment: {
			type: String,
			default: () => ''
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			formData: {
				comment: this.comment,
			}
		}
	},

	methods: {
		async handleSubmit() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				return
			}
			console.log('handleSubmit', this.formData.comment)
			this.$emit('addComment', this.formData.comment)
			this.$emit('close')
		},
	},
	validations() {
		return {
			formData: {
				comment: {
					required: withMessage("Заполните комментарий", required),
					minLength: withMessage("Комментарий должен содержать не менее 5 символов", minLength(5)),
				},
			}
		}
	},
}
</script>
